"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const supportsLocalStorage_1 = __importDefault(require("./utils/supportsLocalStorage"));
const experiments_1 = require("./constants/experiments");
const storageMechanism_1 = require("./constants/storageMechanism");
const setExperiment_1 = __importDefault(require("./experiments/setExperiment"));
const getExperiment_1 = __importDefault(require("./experiments/getExperiment"));
const deleteExperiment_1 = __importDefault(require("./experiments/deleteExperiment"));
const shouldAssignToAATest_1 = __importDefault(require("./utils/shouldAssignToAATest"));
const isAATestExpired_1 = __importDefault(require("./utils/isAATestExpired"));
const getExperimentGoalChoice_1 = __importDefault(require("./utils/getExperimentGoalChoice"));
const getActiveExperiments_1 = __importDefault(require("./utils/getActiveExperiments"));
exports.default = (experiments, config) => {
    if (!supportsLocalStorage_1.default() || !experiments || !config)
        return;
    // ----- CHECK FOR EXISTING ACTIVE EXPERIMENTS -----
    const { availableExperimentsGroupedByGoal, availableExperimentGoalKeys, experimentsAlreadyActiveForCurrentUser } = getActiveExperiments_1.default(experiments, config);
    // * Check if user already has A/A test
    const controlTestExperimentValue = getExperiment_1.default(experiments_1.CONTROL_TEST, 'controlTest');
    if (controlTestExperimentValue !== null) {
        if (isAATestExpired_1.default(controlTestExperimentValue)) {
            deleteExperiment_1.default(experiments_1.CONTROL_TEST, 'controlTest', storageMechanism_1.StorageMechanism.LocalStorage);
            // Do not return here. Allow user to be re-assigned to an experiment again
        }
        else {
            config.onSetExperiment({
                experimentGoal: experiments_1.CONTROL_TEST,
                experimentName: 'controlTest',
                variantTitle: controlTestExperimentValue.title
            });
            return []; // Early return - User already assigned to valid A/A control test
        }
    }
    // * Check if user already has active experiments
    if (experimentsAlreadyActiveForCurrentUser.length > 0) {
        // TODO: Assign user to all other active experiments for currentGoal (some may be new)
        for (const currentExperiment of experimentsAlreadyActiveForCurrentUser) {
            const currentExperimentValue = getExperiment_1.default(currentExperiment.goal, currentExperiment.name);
            const currentExperimentVariant = currentExperiment.variants.find(variant => variant.value === currentExperimentValue) || { title: 'UNKNOWN' };
            config.onSetExperiment({
                experimentGoal: currentExperiment.goal,
                experimentName: currentExperiment.name,
                variantTitle: currentExperimentVariant.title
            });
        }
        return [];
    }
    // ----- ASSIGN USER TO EXPERIMENTS -----
    // * A/A Test (10% chance)
    if (shouldAssignToAATest_1.default()) {
        const controlTestVariantTitle = `${Math.random() * 100 > 50}`;
        setExperiment_1.default(experiments_1.CONTROL_TEST, 'controlTest', { createdAt: Date.now(), title: controlTestVariantTitle });
        config.onSetExperiment({
            experimentGoal: experiments_1.CONTROL_TEST,
            experimentName: 'controlTest',
            variantTitle: controlTestVariantTitle
        });
        return []; // Early return - user now assigned to AA
    }
    if (availableExperimentGoalKeys.length === 0)
        return []; // Early return - No experiments available
    // * Pick available experiment goal (equal chance between available goal types)
    const selectedExperimentGoal = availableExperimentGoalKeys[getExperimentGoalChoice_1.default(availableExperimentGoalKeys)];
    const selectedExperiments = availableExperimentsGroupedByGoal[selectedExperimentGoal];
    // * Assign user to a variant for each experiment matching selectedExperimentGoal
    for (const selectedExperiment of selectedExperiments) {
        const selectedVariant = selectedExperiment.variants[Math.floor(Math.random() * selectedExperiment.variants.length)];
        setExperiment_1.default(selectedExperimentGoal, selectedExperiment.name, selectedVariant.value);
        config.onSetExperiment({
            experimentGoal: selectedExperimentGoal,
            experimentName: selectedExperiment.name,
            variantTitle: selectedVariant.title
        });
    }
    return selectedExperiments;
};
//# sourceMappingURL=setupExperiments.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@pizza-hut/lib-experiments/lib/setupExperiments.js
// module id = Jj3O
// module chunks = 69